module.exports = __webpack_public_path__ + "images/fa-oth-bg-pricing.webp";